export const messages = {
  en: {
    refundCart: {
      queryCondition: 'Query Conditions',
      orderNumber: 'Order Number',
      selectStatus: 'Select Status',
      productName: 'Product Name',
      query: 'Query',
      refundOrder: 'Refund Orders',
      productSpec: 'Product Specification',
      userName: 'User Name',
      refundAmount: 'Refund Amount',
      orderStatus: 'Order Status',
      refundReason: 'Refund Reason',
      applyTime: 'Application Time',
      applyRefund: 'Apply for Refund',
      refundSuccess: 'Refund Success',
      hasRefunded: 'Already Refunded'
    }
  },
  zh: {
    refundCart: {
      queryCondition: '查询条件',
      orderNumber: '订单编号',
      selectStatus: '请选择状态',
      productName: '请输入商品名称',
      query: '查询',
      refundOrder: '退货订单',
      productSpec: '商品规格',
      userName: '用户名称',
      refundAmount: '退款金额',
      orderStatus: '订单状态',
      refundReason: '退款原因',
      applyTime: '申请时间',
      applyRefund: '申请退款',
      refundSuccess: '退货成功',
      hasRefunded: '已退款'
    }
  }
}